export interface ILibrariesState {}

let librariesState: ILibrariesState = {};

export default librariesState;